import {
	BaseError,
} from './BaseError';

export class GetCompanyInformationError extends BaseError {
	constructor(message: string, stack?: string) {
		super(message, stack);
	}
}


